module.exports = __webpack_public_path__ + "static/media/inplay-broadcast-icon.e5eb4298.svg";